import {
    useCallback,
    useMemo,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import BulkUploadPopupWrapper from 'app/shared-components/BulkUploadPopupWrapper'
import useLabel from 'app/hooks/useLabel'
import SimpleBulkUpload from 'app/shared-components/SimpleBulkUpload'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import requests from 'app/requests/ContractBasis/LaneFees.requests'
import {
    BatchOperationPayload,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.types'
import {
    BatchEntity,
} from 'app/enums/common.enums'

import {
    LaneFeesFilterRequestResponse,
} from '../LaneFees.types'
import getColumns from './LaneFeesBulkUploadPopup.columns'
import {
    feedbackFormFields,
    updateFormFields,
} from './LaneFeesBulkUploadPopup.fields'
import useStyles from './LaneFeesBulkUploadPopup.styles'
import PopupWarning from './PopupWarning'

const LaneFeesBulkUploadPopup = () => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const {
        LaneFees: LanesFeesRoutes,
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()

    const generateLink = useCallback((id: number, domainPath: string[]) => {
        return id ? generateSkyNetLink({
            domainPath,
            params: {
                key: id,
            },
        }) : null
    }, [])

    const columns = useMemo(() => {
        return getColumns({
            l,
            getLaneNumberLink: (id) => {
                return generateLink(id, LanesFeesRoutes.Overview.path)
            },
            getLaneGroupLink: (id) => {
                return generateLink(id, LaneGroupsRoutes.Overview.path)
            },
            linkStyles: classes.link,
        })
    }, [
        LaneGroupsRoutes.Overview.path,
        LanesFeesRoutes.Overview.path,
        classes.link,
        generateLink,
        l,
    ])

    const mapUploadParams = useCallback((
        data: BatchOperationPayload<LaneFeesFilterRequestResponse>,
    ) => {
        const {
            id, validTo, batchOperationId,
        } = data

        return requests.laneFeesBatchValidTo({
            laneFeesId: id,
            data: {
                validTo,
                batchOperationId,
            },
        })
    }, [])

    const renderChildren = useCallback(({
        closePopup,
        filtersData,
    }) => {
        return (
            <SimpleBulkUpload<LaneFeesFilterRequestResponse>
                entity={BatchEntity.LANE_FEES}
                dataRequest={requests.filterRequestAll}
                dataRequestKey={RequestKeys.getLaneFeesFilterRequest}
                uploadParamsMapper={mapUploadParams}
                dataUpdateFormInfoComponent={<PopupWarning />}
                feedbackFormFields={feedbackFormFields}
                dataUpdateFormFields={updateFormFields}
                errorFeedbackColumns={columns}
                filterParams={filtersData}
                onCancel={closePopup}
            />
        )
    }, [
        columns,
        mapUploadParams,
    ])

    return (
        <BulkUploadPopupWrapper
            dialogTitle="UPDATE VALID TO IN A BULK"
            renderChildren={renderChildren}
        />
    )
}

export default LaneFeesBulkUploadPopup
